import React, { Component, Fragment } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import TextInput from './TextInput';
import TextBoxValid from './TextBoxValid';
import SendModal from './SendModal';
import SelectFieldValid from './SelectFieldValid';
import TextField from '../../artzu-ui/src/TextField';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import Option from '../../artzu-ui/src/Option';
import { Link } from 'react-router-dom';
import DesktopFooter from './DesktopFooter';
import Footer from './Footer';

export const editDashes = mobile => {
  let numbers = [];
  if (mobile === '') {
    return mobile;
  }
  mobile.split('').forEach(char => {
    if (char !== '-') {
      numbers.push(char);
    }
  });
  numbers = numbers.join('');
  let returnVal = '';

  returnVal += numbers[3] ? `${numbers.slice(0, 3)}-` : numbers.slice(0);
  returnVal += numbers[6] ? `${numbers.slice(3, 6)}-` : numbers.slice(3);
  returnVal += numbers.slice(6);

  return returnVal;
};

export const handleOperatingCity = city => {
  switch (city) {
    case 'toronto':
      return 'Toronto';
    case 'new_york':
      return 'New York';
    default:
      return city;
  }
};

class NewContactForm extends Component {
  constructor(props) {
    super(props);
    const {
      first_name,
      last_name,
      email,
      mobile,
      loggedIn,
      operatingCity,
      pathname
    } = this.props;
    this.state = {
      name: first_name && last_name ? `${first_name} ${last_name}` : '',
      firstName: first_name || '',
      lastName: last_name || '',
      email: email || '',
      mobile: mobile || '',
      subject: '',
      city: pathname.includes('tor')
        ? 'toronto'
        : pathname.includes('sf')
        ? 'san_francisco'
        : 'new_york',
      message: '',
      modal: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { first_name, last_name, mobile, operatingCity } = this.props;
    const { firstName, lastName } = this.state;
    if (mobile !== prevProps.mobile) {
      this.setState({ mobile });
    }
    if (
      firstName !== prevState.firstName ||
      lastName !== prevState.lastName
    ) {
      this.setState({ name: `${firstName} ${lastName}` });
    }
    if (operatingCity !== prevProps.operatingCity) {
      this.setState({ operatingCity });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    const { email, name, subject, message, city, mobile } = this.state;

    this.props.client
      .mutate({
        mutation: SEND_MESSAGE,
        variables: {
          messageArgs: {
            name,
            email,
            subject,
            message,
            operatingCity: city,
            mobile: mobile === '' ? 'N/A' : mobile
          }
        }
      })
      .then(() =>
        this.setState({
          modal: true,
          message: ''
        })
      );
  };

  closeModal = () => this.setState({ modal: false });

  handleChange = ({ target }) => {
    const { name } = target;
    this.setState({ [name]: target.value });
  };

  render() {
    const {
      name,
      firstName,
      lastName,
      email,
      mobile,
      message,
      subject,
      city,
      modal
    } = this.state;
    const { loggedIn, operatingCity } = this.props;
    console.log(this.props.client);
    console.log(city);
    const cityShown =
      city === 'toronto'
        ? 'Toronto'
        : city === 'new_york'
        ? 'New York City'
        : 'San Francisco';
    return (
      <Fragment>
        {!modal ? (
          <div className="container formContainer">
            <ValidatorForm
              instantValidate
              onSubmit={e => this.handleSubmit(e)}>
              <div className="contact__container--form">
                <div className="formInputBox">
                  <TextInput
                    floatingLabelText="First Name"
                    onChange={this.handleChange}
                    name="firstName"
                    value={firstName}
                    validators={['required']}
                    errorMessages={['This field is required']}
                  />
                </div>
                <div className="formInputBox">
                  <TextInput
                    floatingLabelText="Last Name"
                    onChange={this.handleChange}
                    name="lastName"
                    value={lastName}
                    validators={['required']}
                    errorMessages={['This field is required']}
                  />
                </div>
                <div className="formInputBox">
                  <TextInput
                    floatingLabelText="Email"
                    onChange={this.handleChange}
                    name="email"
                    value={email}
                    validators={['required', 'isEmail']}
                    errorMessages={[
                      'This field is required',
                      'Email is not valid'
                    ]}
                  />
                </div>
                <div className="formInputBox">
                  <TextInput
                    floatingLabelText="Phone"
                    onChange={this.handleChange}
                    name="mobile"
                    value={editDashes(mobile)}
                    validators={[
                      'matchRegexp:^[0-9]{3}-[0-9]{3}-[0-9]{4}$'
                    ]}
                    errorMessages={['Mobile number is not valid']}
                  />
                </div>
                {loggedIn && !!operatingCity ? (
                  <div className="name" style={{ paddingBottom: '18px' }}>
                    <TextField
                      heading="Operating City"
                      onChange={() => {}}
                      width="100%"
                      value={handleOperatingCity(operatingCity)}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="formInputBox">
                    <SelectFieldValid
                      onChange={(value, heading) =>
                        this.setState({ city: value })
                      }
                      title="Operating City"
                      validators={['required']}
                      errorMessages={['This field is required']}
                      name="city"
                      value={cityShown}>
                      <Option label="Toronto" value="toronto" />
                      <Option label="New York City" value="new_york" />
                      <Option
                        label="San Francisco"
                        value="san_francisco"
                      />
                    </SelectFieldValid>
                  </div>
                )}
                <div className="formInputBox">
                  <SelectFieldValid
                    onChange={(value, heading) =>
                      this.setState({ subject: value })
                    }
                    title="Subject"
                    validators={['required']}
                    errorMessages={['This field is required']}
                    name="subject"
                    value={subject}>
                    <Option
                      label="General Inquiries"
                      value="general-inquiries"
                    />
                    <Option
                      label="Application Inquiries"
                      value="application-inquiries"
                    />
                    <Option
                      label="Current Driver Inquiries"
                      value="current-driver-inquiries"
                    />
                    <Option
                      label="Other Inquiries"
                      value="other-inquiries"
                    />
                    <Option
                      label="Feedback / Report Issue"
                      value="feedback-report-issue"
                    />
                  </SelectFieldValid>
                </div>
                <div className="message">
                  <TextBoxValid
                    heading="Message"
                    onChange={this.handleChange}
                    name="message"
                    value={message}
                    validators={['required']}
                    errorMessages={['This field is required']}
                  />
                </div>
                <div className="further-info">
                  For further information on how we process your personal
                  data when you submit a request please see our{' '}
                  <Link
                    to={
                      city === 'toronto'
                        ? '/tor/privacy'
                        : city === 'new_york'
                        ? '/nyc/privacy'
                        : '/sf/privacy'
                    }>
                    privacy policy
                  </Link>
                  .
                </div>
              </div>

              <DesktopFooter
                onClick={() => {
                  const input = document.getElementById('submit-button');
                  input.click();
                  var main = document.getElementById('main');
                  main.scrollTo(0, 0);
                }}
              />
              <button
                id="submit-button"
                style={{ display: 'none' }}
                type="submit"
              />
            </ValidatorForm>
          </div>
        ) : (
          <SendModal closeModal={this.closeModal} />
        )}
      </Fragment>
    );
  }
}

const SEND_MESSAGE = gql`
  mutation sendMessage($messageArgs: MessageAttributes!) {
    sendMessage(messageArgs: $messageArgs) {
      message {
        name
        email
        subject
        message
        operatingCity
        mobile
      }
    }
  }
`;
export default withApollo(NewContactForm);



// WEBPACK FOOTER //
// ./src/components/NewContact/NewContactForm.js